var $7c88c76899171bad$exports = {};
$7c88c76899171bad$exports = {
    "colorSwatchPicker": `Barvne palete`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izberite element`,
    "tableResizer": `Spreminjanje velikosti`
};


export {$7c88c76899171bad$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
